import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import BackArrow from '../../assets/images/Frame_18177.png';
import axiosInstance from '../../api/axiosInstance';

const doctorsData = [
  { id: 1, name: "Prof.Saurabh Singh", designation: "MS, MCH (Orthopedics)", specialty: "Orthopedics" },
  { id: 2, name: "Prof.Amit Rastogi", designation: "MS (Orthopedics)", specialty: "Orthopedics" },
  { id: 3, name: "Prof.Shivam Sinha", designation: "MS (Orthopedics)", specialty: "Orthopedics" },
  { id: 4, name: "Prof. Rajesh Meena", designation: "MD Anesthesia, PDCC", specialty: "Cardiology" },
  { id: 5, name: "Dr. Kavita Meena", designation: "MD Anesthesia, PDCC", specialty: "Neurology" },
  { id: 6, name: "Dr.Alok Rai", designation: "MS (Orthopedics)", specialty: "Orthopedics" },
  { id: 7, name: "Dr.Chanchal Kumar Singh", designation: "MS (Orthopedics)", specialty: "Orthopedics" },
  { id: 8, name: "Dr.S.K.Bhartiya", designation: "MS (General Surgery)", specialty: "Surgery" },
  { id: 9, name: "Dr.Sanjay Yadav", designation: "MS (Orthopedics)", specialty: "Orthopedics" },
  { id: 10, name: "Dr.Shashi Prakash Mishra", designation: "MS (Plastic Surgery)", specialty: "Plastic Surgery" },
  { id: 11, name: "Dr.Subham Srivastava", designation: "MS (Orthopedics)", specialty: "Orthopedics" },
  { id: 12, name: "Dr.Sudipta Bera", designation: "MS (Plastic Surgery)", specialty: "Plastic Surgery" },
  { id: 13, name: "Dr.Umesh Kumar", designation: "MS (Plastic Surgery)", specialty: "Plastic Surgery" },
  { id: 14, name: "Dr.Vaibhav Jain", designation: "MS (Plastic Surgery)", specialty: "Plastic Surgery" },
  { id: 15, name: "Dr.Vivek Katiyar", designation: "MS (General Surgery)", specialty: "ENT" },
  { id: 16, name: "Prof.N.K.Agarwal", designation: "MS (Plastic Surgery)", specialty: "Plastic Surgery" },
];

const BookAppointment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const patientMrno = location.state?.mrno;
  const patientData = location.state?.patientData;

  const [selectedDoctor, setSelectedDoctor] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [orderId, setOrderId] = useState('');

  const handleDoctorChange = (e) => {
    const doctorName = e.target.value;
    setSelectedDoctor(doctorName);
    setError('');
  };

  const handleConfirm = async () => {
    if (!selectedDoctor) {
      setError('Please select a doctor');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // Call backend to create Razorpay order
      const response = await axiosInstance.post('/api/patient/create-order', {
        amount: 3000, // Amount in paise (₹30)
        currency: 'INR',
        patientMrno: patientMrno,
      });

      const { order_id } = response.data;
      setOrderId(order_id);

      // Programmatically submit the form
      const form = document.getElementById('razorpay-checkout-form');
      form.submit();
    } catch (err) {
      setError('Failed to initiate payment. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <div className="flex items-center mb-6">
        <Link
          to="/login"
          state={{ patientId: patientMrno }}
          className="flex w-28 px-4 py-3 bg-[#0FA968] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200"
          style={{ fontFamily: 'Roboto', fontSize: '20px', fontWeight: '500', lineHeight: '23.44px' }}
        >
          <img src={BackArrow} alt="Back" className="mr-2 w-6 h-6" />
          Login
        </Link>
        <span
          className="ml-4 text-2xl font-semibold"
          style={{ fontFamily: 'Roboto', fontSize: '28px', fontWeight: '600', lineHeight: '32.81px' }}
        >
          Book Consultant
        </span>
      </div>

      {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

      <div className="grid grid-cols-4 gap-4">
        {doctorsData.map((doctor) => (
          <label key={doctor.id} className="flex flex-col cursor-pointer">
            <input
              type="radio"
              name="doctor"
              value={doctor.name}
              checked={selectedDoctor === doctor.name}
              onChange={handleDoctorChange}
              className="hidden"
              disabled={loading}
            />
            <span
              className={`px-3 py-2 bg-white rounded-lg text-[#27272A] text-center ${
                selectedDoctor === doctor.name
                  ? 'bg-[#DAFEEF] text-[#0FA968] border border-[#0FA968]'
                  : 'hover:bg-[#DAFEEF] hover:text-[#0FA968] hover:border hover:border-[#0FA968]'
              } ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              <p className="font-semibold">{doctor.name}</p>
              <p className="text-sm text-gray-600">{doctor.designation}</p>
              <p className="text-sm text-gray-600">{doctor.specialty}</p>
            </span>
          </label>
        ))}
      </div>

      <form
        id="razorpay-checkout-form"
        method="POST"
        action="https://api.razorpay.com/v1/checkout/embedded"
      >
        <input type="hidden" name="key_id" value="rzp_test_l89WuDAlW3BrxK" /> {/* Replace with your Razorpay Key ID */}
        <input type="hidden" name="amount" value="3000" /> {/* ₹30 in paise */}
        <input type="hidden" name="currency" value="INR" />
        <input type="hidden" name="order_id" value={orderId} />
        <input type="hidden" name="name" value="Trauma Centre BHU" />
        <input type="hidden" name="description" value="Consultant Appointment Payment" />
        <input
          type="hidden"
          name="image"
          value="https://traumacentrebhu.com/static/media/logo.241d0eaa536833244497.jpg"
        />
        <input
          type="hidden"
          name="prefill[name]"
          value={
            patientData
              ? `${patientData.firstName || ''}  ${patientData.middleName || ''} ${patientData.lastName || ''}`.trim()
              : 'Gaurav Kumar'
          }
        />
        <input type="hidden" name="prefill[contact]" value={patientData?.mobile || '9123456780'} />
        <input
          type="hidden"
          name="prefill[email]"
          value={patientData?.emailAddress || 'gaurav.kumar@example.com'}
        />
        <input
          type="hidden"
          name="notes[shipping address]"
          value={patientData?.address || 'L-16, The Business Centre, 61 Wellfield Road, New Delhi - 110001'}
        />
        <input type="hidden" name="callback_url" value="https://example.com/payment-callback" />
        <input type="hidden" name="cancel_url" value="https://example.com/payment-cancel" />
      </form>

      <div className="flex justify-center mt-6 gap-4">
        <button
          onClick={handleConfirm}
          className={`px-4 py-2 bg-[#0FA968] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200 ${
            loading ? 'opacity-50 cursor-not-allowed' : ''
          }`}
          style={{ fontFamily: 'Roboto', fontSize: '16px' }}
          disabled={loading}
        >
          {loading ? (
            <div className="w-6 h-6 border-4 border-white border-t-transparent rounded-full animate-spin mx-auto"></div>
          ) : (
            'Book Consultant'
          )}
        </button>
      </div>
    </div>
  );
};

export default BookAppointment;